import { Observable } from "rxjs"
import { filter, map } from "rxjs/operators"
import { StateObservable } from "redux-observable"
import type { EpicDependencies } from "../../rxjs/configureEpics"
import { Action, StateObject } from "../../redux/types"
import { invalidateMenuData, MenuDataEntity } from "./actions"
import { PRODUCT_DUPLICATE_SUCCESS, PRODUCTS_AND_CATEGORIES_DELETED } from "./itemsCategories/actions"
import { MODIFIER_GROUP_LOCATION_SAVE_SUCCESS, MODIFIER_GROUPS_DELETED } from "./modifierGroups/actions"
import { MODIFIER_LOCATION_SAVE_SUCCESS, MODIFIERS_DELETED } from "./modifiers/actions"
import { OPTION_GROUP_LOCATION_SAVE_SUCCESS, OPTION_GROUPS_DELETED } from "./optionGroups/actions"

// Only actions dispatched *after* the request finished belong here - invalidating on an optimistic
// action (the reducer applies those before the request is sent) would refetch data the backend has
// not updated yet. Such mutations emit invalidateMenuData from their own epic's success branch.
const INVALIDATION_MAP: Record<string, MenuDataEntity[]> = {
    [MODIFIERS_DELETED]: ["modifierGroups", "itemDetails"],
    [MODIFIER_LOCATION_SAVE_SUCCESS]: ["itemDetails"],

    // The group save successes are absent on purpose: they are also emitted while assigning a new
    // group to an open item detail, where dropping that detail would unmount the form and lose the
    // assignment. Their epics invalidate from the non-assigning branch instead.
    [MODIFIER_GROUP_LOCATION_SAVE_SUCCESS]: ["itemDetails"],
    [MODIFIER_GROUPS_DELETED]: ["modifiers", "itemDetails"],

    [OPTION_GROUP_LOCATION_SAVE_SUCCESS]: ["itemDetails"],
    [OPTION_GROUPS_DELETED]: ["itemsList", "itemDetails"],

    [PRODUCTS_AND_CATEGORIES_DELETED]: ["optionGroups", "modifierGroups", "itemDetails"],
    [PRODUCT_DUPLICATE_SUCCESS]: ["optionGroups", "modifierGroups", "itemDetails"],
}

export const menuDataInvalidationEpic = (
    actions$: Observable<Action>,
    _state$: StateObservable<StateObject>,
    _deps: EpicDependencies
) =>
    actions$.pipe(
        filter((action: Action) => !!INVALIDATION_MAP[action.type]),
        map((action: Action) => invalidateMenuData(INVALIDATION_MAP[action.type]))
    )

export default [menuDataInvalidationEpic]
